import '../sass/frontend.scss';

jQuery(function(){
    const $body = jQuery('body');

    /**
     * @param {int} slideToIndex
     * @param {int} currentIndex
     * @param {boolean} clockwiseDirection
     * @param {function} callback
     */
    function showSlide(slideToIndex, currentIndex, clockwiseDirection, callback)
    {
        if (slideToIndex === currentIndex) {
            return;
        }

        const slides = jQuery('.swoo-discount-cross-sell-box-product.slide');
        const $currentSlide = slides.eq(currentIndex);

        $currentSlide.animate({left: clockwiseDirection ? '100%' : '-100%'}, 500, () => {
            $currentSlide.css('display', 'none');
        });

        const $toSlide = slides.eq(slideToIndex);
        $toSlide.css('display', 'flex').css('left', clockwiseDirection ? '-100%' : '100%')
            .animate({left: '0%'}, 500, () => {
                callback(slideToIndex);
            });
    }

    /**
     * @return void
     */
    function resetSlider()
    {
        showSlide(0, currentIndex, false, (index) => {
            currentIndex = index;
            const $dotToSetActive = jQuery('#swoo-discount-dot-' + currentIndex);
            setActiveDot($dotToSetActive);
        });
    }

    /**
     * @param {jQuery} $clickedDot
     */
    function setActiveDot($clickedDot)
    {
        const $allDots = jQuery('.swoo-discount-cross-sell-dot');
        $allDots.removeClass('active');
        $clickedDot.addClass('active');
    }

    let currentIndex = 0;
    $body.on('click', '.swoo-discount-chevrons.right, .swoo-discount-chevron.right', function() {
        jQuery(this).addClass('disabled');
        const slides = jQuery('.swoo-discount-cross-sell-box-product.slide');
        const slideCount = slides.length;
        let slideToIndex = currentIndex + 1;
        if (slideToIndex > (slideCount - 1)) {
            slideToIndex = 0;
        }
        showSlide(slideToIndex, currentIndex, true, (index) => {
            currentIndex = index;
            const $dotToSetActive = jQuery('#swoo-discount-dot-' + currentIndex);
            setActiveDot($dotToSetActive);
            jQuery(this).removeClass('disabled');
        });
    });

    $body.on('click', '.swoo-discount-chevrons.left, .swoo-discount-chevron.left', function() {
        jQuery(this).addClass('disabled');
        const slides = jQuery('.swoo-discount-cross-sell-box-product.slide');
        const slideCount = slides.length;
        let slideToIndex = currentIndex - 1;
        if (slideToIndex < 0) {
            slideToIndex = slideCount - 1;
        }
        showSlide(slideToIndex, currentIndex, false, (index) => {
            currentIndex = index;
            const $dotToSetActive = jQuery('#swoo-discount-dot-' + currentIndex);
            setActiveDot($dotToSetActive);
            jQuery(this).removeClass('disabled');
        });
    });

    $body.on('click', '.swoo-discount-cross-sell-dot', function() {
        const $dots = jQuery('.swoo-discount-cross-sell-dot');
        $dots.addClass('disabled');
        const $clickedDot = jQuery(this);
        setActiveDot($clickedDot);
        let dotIndex = parseInt($clickedDot.data('index'));
        if (dotIndex === currentIndex) {
            return;
        }
        let direction = dotIndex > currentIndex;
        showSlide(dotIndex, currentIndex, direction, (index) => {
            currentIndex = index;
            const $dotToSetActive = jQuery('#swoo-discount-dot-' + dotIndex);
            setActiveDot($dotToSetActive);
            $dots.removeClass('disabled');
        });
    });

    $body.on('click', '.coupon-code-area-title', function() {
        if (!jQuery('.coupon-code-area-input').is(':visible')) {
            jQuery('.coupon-code-area-input').slideDown(function() {
                jQuery('.dashicons-arrow-down-alt2').hide();
                jQuery('.dashicons-arrow-up-alt2').show();
            });
        } else {
            jQuery('.coupon-code-area-input').slideUp(function() {
                jQuery('.dashicons-arrow-up-alt2').hide();
                jQuery('.dashicons-arrow-down-alt2').show();
            });
        }
    });

    // Listen for changes in the variations form
    $body.on('show_variation', 'form.variations_form', function(event, variation) {
        // Set the variation ID which is needed when the purhcase button is clicked
        jQuery('#selected_variation_id').val(variation.variation_id);
    });

    function showAjaxAnimation()
    {
        jQuery('#swoo-floating-ajax-cart-popup-pro-ajax-animation').show();
    }

    function hideAjaxAnimation()
    {
        jQuery('#swoo-floating-ajax-cart-popup-pro-ajax-animation').hide();
    }

    function showCart()
    {
        jQuery('#swoo-floating-ajax-cart-popup-pro-background').show();
        jQuery('#swoo-floating-ajax-cart-popup-pro').show();
        $body.css('overflow', 'hidden');
    }

    function hideCart()
    {
        jQuery('#swoo-floating-ajax-cart-popup-pro-background').hide();
        jQuery('#swoo-floating-ajax-cart-popup-pro').hide();
        $body.css('overflow', '');
    }

    /**
     *
     * @param cartContentHtml
     * @param displayCart
     */
    function pushCartContentHtmlToDiv(cartContentHtml, displayCart = true) {
        jQuery('#swoo-floating-ajax-cart-popup-pro-wrapper').html(cartContentHtml);
        if (displayCart) {
            showCart();
        }
        resetSlider();
        // Notify scripts about the cart update (e.g. the swoo discount plugin so that quantity discount table can be updated)
        jQuery(document.body).trigger('updated_wc_div');
    }

    // Toggle floating cart
    $body.on('click', '#swoo-floating-ajax-cart-popup-pro-toggle, #swoo-floating-ajax-cart-popup-pro-header-close, #swoo-floating-ajax-cart-popup-pro-continue-shopping, #swoo-floating-ajax-cart-popup-pro-background', function() {
        if (this.id === 'swoo-floating-ajax-cart-popup-pro-continue-shopping' && floatingCartAjax.continue_shopping_url) {
            window.location.href = floatingCartAjax.continue_shopping_url;
            return;
        }

        if (!jQuery('#swoo-floating-ajax-cart-popup-pro-background').is(':visible')) {
            showCart();
        } else {
            hideCart();
        }
    });

    function validate(e)
    {
        var isValid = true;
        var $requiredFields = jQuery('form.cart').find('[required]');
        var firstInvalidField = null;

        // Remove any existing error messages
        jQuery('.error-message').remove();

        $requiredFields.each(function() {
            var $this = jQuery(this);
            if ($this.val() === '') {
                isValid = false;
                $this.css('border', '1px solid red'); // Optionally highlight the empty field
                if (firstInvalidField === null) {
                    firstInvalidField = $this;
                }

                let errorMessage = jQuery('#swoo-floating-ajax-cart-popup-pro').data('required-error-message');

                // Append error message
                $this.after('<div class="error-message" style="color: red;">' + errorMessage + '</div>');
            } else {
                $this.css('border', ''); // Reset the border if the field is filled
            }
        });

        if (!isValid) {
            e.preventDefault(); // Prevent form submission

            if (firstInvalidField !== null) {
                var fieldOffset = firstInvalidField.offset().top;
                var windowHeight = jQuery(window).height();
                var scrollToPosition = fieldOffset - (windowHeight / 2) + (firstInvalidField.outerHeight() / 2);

                jQuery('html, body').animate({
                    scrollTop: scrollToPosition
                }, 500);
                firstInvalidField.focus();
            }
        }
    }

    // Single pages
    $body.on('click', '.single_add_to_cart_button', function (e) {

        if (jQuery(this).hasClass('disabled')) {
            return;
        }

        e.preventDefault();

        showAjaxAnimation();

        validate(e);

        var $thisbutton = jQuery(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0;

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        jQuery(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        jQuery.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (!response.success) {
                    showCart();
                    showMessage(response.data.message, "error");
                    hideAjaxAnimation();
                    return false;
                }
                showCart();
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                pushCartContentHtmlToDiv(response.data.cart_contents);
                showMessage(response.data.message, "success");
            },
        });

        return false;
    });



    // Lists
    $body.on('click', '.add_to_cart_button', function (e) {

        e.preventDefault();

        showAjaxAnimation();

        var $thisbutton = jQuery(this),
            product_id = $thisbutton.data('product_id'), // Assuming the button has a data attribute for product ID
            product_qty = 1; // Set quantity to 1 for list items, adjust as needed
        var variation_id = $thisbutton.data('variation_id') || 0; // Handle variations if applicable

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        jQuery(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        jQuery.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (!response.success) {
                    return;
                }
                showCart();
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                pushCartContentHtmlToDiv(response.data.cart_contents);
                showMessage(response.data.message, "success");
            },
        });

        return false;
    });


    $body.on('click', '.swoo-discount-cross-sell-add-to-cart', function (e) {

        e.preventDefault();

        showAjaxAnimation();

        validate(e);

        const $addToCartButton = jQuery(this);
        let productId = $addToCartButton.data('product-id');

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: productId,
            product_sku: '',
            quantity: 1,
            variation_id: 0,
        };

        jQuery(document.body).trigger('adding_to_cart', [$addToCartButton, data]);

        jQuery.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $addToCartButton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $addToCartButton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (!response.success) {
                    return;
                }
                showCart();
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $addToCartButton]);
                pushCartContentHtmlToDiv(response.data.cart_contents);
                showMessage(response.data.message, "success");
            },
        });

        return false;
    });

    // Apply coupon using AJAX
    $body.on('click', '#apply-coupon', function(e) {
        e.preventDefault();
        const $couponCodeField = jQuery('#coupon_code');
        if ($couponCodeField.val().trim() === '') {
            return;
        }
        showAjaxAnimation();
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'apply_coupon',
                coupon_code: $couponCodeField.val(),
                nonce: floatingCartAjax.nonce
            },
            success: function(response){
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });

    function onLoad()
    {
        let ajaxLoad = jQuery('#swoo-floating-ajax-cart-popup-pro-wrapper').hasClass('ajax-load');
        if (!ajaxLoad) {
            return;
        }
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'load',
                nonce: floatingCartAjax.nonce
            },
            success: function(response) {
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents, false);
                }
            }
        });
    }
    onLoad();

    $body.on('click', '#swoo-discount-cross-sell-close', (e) => {
        e.preventDefault();
        jQuery('.swoo-discount-cross-sell-wrapper').hide();
        jQuery('#swoo-discount-cross-sell-you-might-like-mini').show();
        showAjaxAnimation();
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'cache_cross_sell_minimized',
                cross_sell_minimized: 1,
                nonce: floatingCartAjax.nonce
            },
            success: function(response){
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });
    $body.on('click', '#swoo-discount-cross-sell-you-might-like-mini', (e) => {
        e.preventDefault();
        jQuery('#swoo-discount-cross-sell-you-might-like-mini').hide();
        jQuery('.swoo-discount-cross-sell-wrapper').show();
        showAjaxAnimation();
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'cache_cross_sell_minimized',
                cross_sell_minimized: 0,
                nonce: floatingCartAjax.nonce
            },
            success: function(response){
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });

    $body.on('click', '.coupon-code-remove', function(e) {
        e.preventDefault();
        showAjaxAnimation();
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'remove_coupon',
                coupon_code: jQuery(this).closest('.coupon-code').data('coupon-code'),
                nonce: floatingCartAjax.nonce
            },
            success: function(response) {
                if(response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });

    /**
     * @param {string} message
     * @param {string} type
     * @param callback
     * @param {int} timeout
     */
    function showMessage(message, type, callback = function() {}, timeout = 4000)
    {
        const $notification = jQuery('.swoo-floating-ajax-cart-popup-pro-notification.dynamic-notification');

        $notification.html(message);
        $notification.slideDown();

        // Remove any existing type classes
        $notification.removeClass('info success danger');

        if (type === 'error') {
            type = 'danger';
        }

        if (type) {
            $notification.addClass(type);
        }

        setTimeout(() => {
            $notification.slideUp(function() {
                callback();
            });
        }, timeout)
    }

    // Change the item quantity using AJAX
    $body.on('change', '.change-quantity', function(e) {
        e.preventDefault();
        showAjaxAnimation();
        const $quantityInput = jQuery(this);
        var initialQuantity = parseInt($quantityInput.attr('value'));
        var cartItemKey = $quantityInput.data('cart-item-key');
        var quantity = parseInt($quantityInput.val());
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'change_cart_item_quantity',
                cart_item_key: cartItemKey,
                quantity: quantity,
                nonce: floatingCartAjax.nonce
            },
            success: (response) => {
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                    $quantityInput.val(initialQuantity);
                }
            }
        });
    });

    // Increase item quantity using AJAX
    $body.on('click', '.increase-quantity', function(e) {
        e.preventDefault();
        showAjaxAnimation();
        var cartItemKey = jQuery(this).data('cart-item-key');
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'increase_cart_item_quantity',
                cart_item_key: cartItemKey,
                nonce: floatingCartAjax.nonce
            },
            success: function(response) {
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });

    // Decrease item quantity using AJAX
    $body.on('click', '.decrease-quantity', function(e) {
        e.preventDefault();
        showAjaxAnimation();
        var cartItemKey = jQuery(this).data('cart-item-key');
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'decrease_cart_item_quantity',
                cart_item_key: cartItemKey,
                nonce: floatingCartAjax.nonce
            },
            success: function(response) {
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    hideAjaxAnimation();
                    showMessage(response.data.message, "error");
                }
            }
        });
    });

    // Remove item from cart using AJAX
    $body.on('click', '.remove-cart-item', function(e) {
        e.preventDefault();
        showAjaxAnimation();
        const $cartItem = jQuery(this);
        let cartItemKey = $cartItem.data('cart-item-key');
        let productId = $cartItem.data('product-id');
        jQuery.ajax({
            type: 'POST',
            url: floatingCartAjax.ajax_url,
            data: {
                action: 'remove_cart_item',
                cart_item_key: cartItemKey,
                product_id: productId,
                nonce: floatingCartAjax.nonce
            },
            success: function(response) {
                if (response.success) {
                    pushCartContentHtmlToDiv(response.data.cart_contents);
                    showMessage(response.data.message, "success");
                } else {
                    showMessage(response.data.message, "error");
                    hideAjaxAnimation();
                }
            }
        });
    });
});
